import IOrgstructureWithPath from 'CommonTypes/Orgstructure/IOrgstructureWithPath';

export default (orgstructureWithPath: IOrgstructureWithPath[], subdivisionId: number) => {
    const currentSubdivision = orgstructureWithPath.find(
        orgstructure => orgstructure.id === subdivisionId,
    );

    return currentSubdivision ?? null;
};
